import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { Injector, NgModule } from '@angular/core'
import { HttpClientModule } from '@angular/common/http';


import { createCustomElement } from '@angular/elements'
import { ChatModule, ChatWidgetComponent } from './chat/'
import { ChatService } from './chat/chat.service';
import { IconsModule } from './core/icons/icons.module';

@NgModule({
  imports: [BrowserModule, BrowserAnimationsModule, ChatModule, HttpClientModule, IconsModule],
  providers: [ChatService],
  exports: [ChatModule]
})
export class ElementModule {
  constructor(private injector: Injector) {
    console.log("element.module CHAT")
  }

  ngDoBootstrap() {
    const chatWidget = <any>createCustomElement(ChatWidgetComponent, {
      injector: this.injector,
    })
    if (!customElements.get('chat-widget')) { customElements.define('chat-widget', chatWidget); }
  }


}
